import api from "./api";

/* GET PROFILE */
export const getProfile = async () => {
  const res = await api.get("auth/profile/");
  return res.data;
};

/* UPDATE PERSONAL INFO (supports FormData for file uploads) */
export const updateProfile = async (data) => {
  // The API interceptor in api.js already detects FormData and
  // removes the Content-Type header so the browser sets multipart/form-data
  // with the correct boundary automatically.
  const res = await api.patch("auth/profile/", data);
  return res.data;
};

/* UPDATE CONTACT */
export const updateContact = async (data) => {
  const res = await api.patch("auth/profile/contact/", data);
  return res.data;
};

/* CHANGE PASSWORD */
export const changePassword = async (data) => {
  const res = await api.post("auth/change-password/", data);
  return res.data;
};

/* SELF-SERVICE EMPLOYEE PROFILE */
export const getMyEmployeeProfile = async () => {
  const res = await api.get("employees/my-profile/");
  return res.data;
};

export const updateMyEmployeeProfile = async (data) => {
  const res = await api.patch("employees/my-profile/", data);
  return res.data;
};

export const uploadMyEmployeeDocument = async (formData) => {
  const res = await api.post("employees/my-profile/documents/", formData);
  return res.data;
};

export const deleteMyEmployeeDocument = async (docId, password) => {
  const headers = password ? { "X-Confirm-Password": password } : {};
  const res = await api.delete(`employees/my-profile/documents/${docId}/`, { headers, data: { password }, params: { password } });
  return res.data;
};

